import {useAppDispatch} from "@hooks/redux-hooks/hooks";
import React, {MouseEventHandler, useRef, useState} from "react";
import Toggle from "../../components/Toggle";
import {useForm} from 'react-hook-form'
import * as Validation from "@utilities/validationRules";
import {ErrorMessage} from "@hookform/error-message";
import Input from "../../components/wrapperComponents/Input";
import {ActionCreatorWithoutPayload} from "@reduxjs/toolkit/dist/createAction";
import {Credentials} from "@commons/mapping/Credentials";
import {LoginResultRecord} from "@commons/mapping/LoginResultRecord";
import {AsyncThunk} from "@reduxjs/toolkit";
import Loading from "../../components/dataTable/Loading";
import * as AuthActions from "@commons/actions/authentication.action";
import Banner, {bannerStyle} from "../../components/Banner";
import md5 from "md5";
import EyeIconFilled from "../../icons/EyeIconFilled";
import EyeSlashIconFilled from "../../icons/EyeSlashIconFilled";

interface SignInCardProps {
    anonymousAccessSuccess?: ActionCreatorWithoutPayload;
    loginAction: AsyncThunk<LoginResultRecord, Credentials, {}>;
    onHandlePasswordDimenticata: () => void;
}

type Language = 'IT' | 'EN';
export type SignInState = 'READY' | 'CHECKING' | 'SUCCESS' | 'FAILED';
const SignInCard: React.FC<SignInCardProps> = (props) => {
    const withoutAuthenticationTo = props.anonymousAccessSuccess ? true : false;
    // https://react-hook-form.com/ru/faqs/#Howtosharerefusage - E' necessario aggiungere null al generic, in modo da permettere l'inizializzazione successiva di ref...
    const refPassword = useRef<HTMLInputElement | null>(null);

    const [language, setLanguage] = useState<Language>('IT');
    //const [userName, setUserName] = useState<string>(''); - con react-hook-form NON servono piu'!
    //const [password, setPassword] = useState<string>('');- con react-hook-form NON servono piu'!
    const [rememberMe, setRememberMe] = useState<boolean>(true);
    const [showPassword, setShowPassword] = useState<boolean>(false);
    //const urlLogo = 'https://www.ericed.it/images/ericd-logo.svg';
    const urlLogo = `${process.env.PUBLIC_URL}/images/FPnet_logo_HR_L.svg`;
    const altLogo = "FPNet";
    const dispatch = useAppDispatch();

    const [status, setStatus] = useState<SignInState>('READY');
    const dispatchAnonymousAccess = () => {
        if (props.anonymousAccessSuccess)
            dispatch(props.anonymousAccessSuccess());
    }
    type FormData = {
        userName: string | null;
        currentPassword: string | null;
    };
    const defaultValues: FormData = {
        userName: null,
        currentPassword: null
    };
    //const {register, handleSubmit, formState: {errors}} = useForm<FormData>({defaultValues}); CON DEFAULT!!!
    const {register, handleSubmit, formState: {errors}} = useForm<FormData>();

    // Per la password anticipo la registrazione dell'elemento per fare l'override di ref, in modo da avere una copia in <refPassword>
    const {ref, ...rest} = register('currentPassword', {...Validation.required, ...Validation.minLen8});

    //console.log(errors);

    function dispatchLogin(data: FormData) {
        console.log('dispatchLogin');
        setStatus('CHECKING');
        const credentials: Credentials = {
            userName: data.userName!,
            password: md5(data.currentPassword!),
            passwordInChiaro: data.currentPassword!,
            rememberMe
        };

        dispatch(props.loginAction(credentials)).then((res) => {
            console.log(res.type);
            if (res.type === AuthActions.login.fulfilled.type) {
                setStatus('SUCCESS');
                console.log('Login effettuata!');
            } else if (res.type === AuthActions.login.rejected.type) {
                setStatus('FAILED');
                // @ts-ignore
                if (res.payload && res.payload.data && res.payload.data.message) { // @ts-ignore
                    setErrorMsg(res.payload.data.message)
                } else
                    setErrorMsg(`Errore generico! Contattare l'assistenza`);
                console.log('Errore in login!');
            }
        }, () => {
            // NON CI VIENE MAI!!!
        });
    }

    const togglePasswordStatus: MouseEventHandler<HTMLAnchorElement> = (event) => {
        event.preventDefault();
        if (refPassword && refPassword.current) {
            let x = refPassword.current;
            if (x.type === 'password') {
                setShowPassword(true);
                x.type = 'text';
            } else {
                setShowPassword(false);
                x.type = 'password';
            }
        }
    }
    const [errorMsg, setErrorMsg] = useState<string>('');

    const loading = status === 'CHECKING';
    return (
        <>
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-32 w-auto"
                    src={urlLogo || "https://tailwindui.com/img/logos/workflow-mark.svg?color=blue&shade=600"}
                    alt={altLogo || "Workflow"}
                />
                <h2 className="mt-6 text-center text-3xl tracking-tight font-bold">
                    {language === 'IT' && 'Accedi con il tuo account FPNet'}
                    {language === 'EN' && 'Sign in to your account FPNet'}
                </h2>
                <p className="mt-2 text-center text-sm text-gray-600">
                    {withoutAuthenticationTo && language === 'IT' &&
                        <>nbsp;
                            <a href="#" className="font-medium text-blue-600 hover:text-blue-500"
                               onClick={dispatchAnonymousAccess}>
                                puoi proseguire senza autenticazione
                            </a></>}
                    {withoutAuthenticationTo && language === 'EN' &&
                        <>nbsp;
                            <a href="#" className="font-medium text-blue-600 hover:text-blue-500"
                               onClick={dispatchAnonymousAccess}>
                                you can continue without authentication
                            </a></>}
                </p>
            </div>

            <Loading loading={loading} background={false}>
                <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
                    <div className="bg-white py-8 px-4 shadow rounded-lg sm:px-10">
                        <form className="space-y-6 text-sm" onSubmit={handleSubmit(dispatchLogin)}>
                            <div>
                                <label htmlFor='userName' className="block font-medium">
                                    Nome utente
                                </label>
                                <div className="mt-1">
                                    <Input type="text"
                                           autoComplete="userName"
                                           name="userName"
                                           register={register}
                                           errors={errors}
                                           registerOptions={Validation.userName}/>
                                    {/*{errors.userName && <p className="text-rose-700">Inserire il nome utente.</p>}*/}
                                </div>
                            </div>

                            <div>
                                <label htmlFor="current-password" className="block font-medium">
                                    Password
                                </label>
                                <div className="relative mt-1">
                                    <input
                                        type="password"
                                        autoComplete="current-password"
                                        className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
                                        {...rest}
                                        ref={(e) => {
                                            ref(e)
                                            refPassword.current = e;
                                        }}
                                    />
                                    <a className="absolute inset-y-0 right-0 flex items-center rounded-r-md px-2 focus:outline-none" onClick={togglePasswordStatus}>
                                        {refPassword && refPassword.current && refPassword.current.type === 'text' &&
                                            <EyeIconFilled className="h-5 w-5 text-gray-400"/>}

                                        {!showPassword && <EyeSlashIconFilled className="h-5 w-5 text-gray-400"/>}
                                    </a>
                                </div>
                                <ErrorMessage errors={errors} name="currentPassword"/>
                                {/*<p className="text-rose-700">{errors.currentPassword?.message}</p>*/}
                            </div>

                            <div className="grid grid-cols-1 col-end-1 !mt-2">
                                <a href="#" className="font-medium text-blue-600 hover:text-blue-500 text-right"
                                   onClick={() => props.onHandlePasswordDimenticata()}>
                                    Hai dimenticato la password?
                                    {language === 'EN' && 'Forgot your password?'}
                                </a>
                            </div>

                            <div className="flex flex-row flex-wrap !mt-4">
                                <Toggle initialState={rememberMe}
                                        onChange={setRememberMe}
                                        label="Salva dati di accesso"
                                        labelPosition="right"/>
                            </div>

                            {/*{status === 'FAILED' && <Banner style={bannerStyle.xdanger} text="Nome utente o password non validi!"/>}*/}
                            {status === 'FAILED' && <div className="!mt-4">
                                <Banner className="w-full" style={bannerStyle.xdanger} text={errorMsg}/>
                            </div>}
                            <div className="!mt-4">
                                <button type="submit"
                                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600
                                                    hover:bg-blue-700
                                                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                                                    disabled:opacity-50"
                                        disabled={loading}>
                                    Sign in
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </Loading>
        </>
    )
}
export default SignInCard;